
    import React from 'react';
    import {
      Dialog,
      DialogContent,
      DialogHeader,
      DialogTitle,
      DialogDescription,
      DialogFooter,
      DialogClose, // Import DialogClose
    } from "@/components/ui/dialog";
    import { Button } from "@/components/ui/button";
    import { Checkbox } from "@/components/ui/checkbox";
    import { Label } from "@/components/ui/label";

    // Changed props: open -> isOpen, onOpenChange -> onClose, onAgree -> onAccept
    const TermsDialog = ({ isOpen, onClose, onAccept }) => {
      const [agreed, setAgreed] = React.useState(false);
      const appName = "UrbanMint"; // Use correct app name

      const handleAgreeClick = () => {
        if (agreed) {
          onAccept(); // Call the accept handler passed from parent
          // Dialog closing is handled by onOpenChange via overlay/X click, or manually if needed
        }
      };

      // Reset agreed state when dialog opens/closes if needed
      React.useEffect(() => {
         if (!isOpen) {
            setAgreed(false);
         }
      }, [isOpen]);

      return (
        // Use onOpenChange for controlling dialog state from parent/overlay clicks
        <Dialog open={isOpen} onOpenChange={onClose}>
          <DialogContent className="sm:max-w-lg"> {/* Slightly wider */}
            <DialogHeader>
              <DialogTitle>Terms of Service</DialogTitle>
              <DialogDescription>
                Please read and agree to our terms before using {appName}.
              </DialogDescription>
            </DialogHeader>
            <div className="py-4 space-y-4 max-h-[60vh] overflow-y-auto pr-2"> {/* Added padding right for scrollbar */}
              <p className="text-sm">
                Welcome to {appName}! By using our services, you agree to these terms.
              </p>
              <h4 className="font-semibold">1. Service Description</h4>
              <p className="text-sm text-muted-foreground">
                {appName} provides financial literacy tools, credit score information (potentially sourced from third parties), debt management suggestions, and mentorship connections. We are not a credit repair organization, financial advisor, or lender. All information is for educational purposes only.
              </p>
              <h4 className="font-semibold">2. User Responsibilities</h4>
              <p className="text-sm text-muted-foreground">
                You are responsible for the accuracy of the information you provide. You agree to use the service responsibly and legally. You understand that financial decisions based on our information are your own responsibility. Interactions with mentors are subject to your own judgment.
              </p>
              <h4 className="font-semibold">3. Data Privacy</h4>
              <p className="text-sm text-muted-foreground">
                We take your privacy seriously. Please review our Privacy Policy for details on how we collect, use, and protect your data. Requesting credit reports involves sharing personal information with credit bureaus as required by law. Mentor contact information is shared based on their consent.
              </p>
              <h4 className="font-semibold">4. Disclaimers</h4>
              <p className="text-sm text-muted-foreground">
                Credit scores and financial information can change. We do not guarantee the accuracy or completeness of third-party data or mentor advice. We are not liable for any decisions you make based on the information provided or interactions facilitated by the Service.
              </p>
              <h4 className="font-semibold">5. Mentorship</h4>
               <p className="text-sm text-muted-foreground">
                  {appName} facilitates connections between users (mentees) and volunteer mentors. We perform basic checks on mentor applications but do not guarantee the qualifications, advice, or conduct of any mentor. Users interact with mentors at their own risk. Report any inappropriate conduct immediately.
               </p>
              {/* Add more terms as needed */}
            </div>
            <DialogFooter className="flex-col sm:flex-row items-center gap-4 pt-4 border-t"> {/* Added border */}
              <div className="flex items-center space-x-2">
                <Checkbox id="termsDialogCheckbox" checked={agreed} onCheckedChange={setAgreed} />
                <Label htmlFor="termsDialogCheckbox" className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                  I have read and agree to the terms
                </Label>
              </div>
              {/* Removed DialogClose, button handles action */}
              <Button type="button" onClick={handleAgreeClick} disabled={!agreed}>
                Agree & Continue
              </Button>
            </DialogFooter>
          </DialogContent>
        </Dialog>
      );
    };

    export default TermsDialog;
  